const common = {
  "user": {
    "unknown": "(알 수 없음)"
  },
  "queryState": {
    "imageLoading": "이미지 불러오는 중",
    "retry": "다시 시도",
    "loadFailedGeneric": "정보를 불러오지 못했습니다",
  },
  "reviewMode": {
    "label": "검수 모드",
    "exit": "검수 모드 끝내기",
  },
  "notCompleted": {
    "view3d": "3D(mesh)는 아직 구축되지 않았습니다",
    "view2d": "2D(정사영상 · DEM)는 아직 구축되지 않았습니다",
    "values": "{{dates}}: 처리가 아직 끝나지 않아 계산하지 않습니다",
    "issueWrite": "처리가 아직 끝나지 않아 이슈 좌표를 저장할 수 없습니다",
    "tools3d": "처리가 아직 끝나지 않아 이슈 생성과 종단 측정은 쓸 수 없습니다",
    "profile": "처리가 아직 끝나지 않아 단면을 볼 수 없습니다",
    "coordinates": "처리가 아직 끝나지 않아 좌표는 고칠 수 없습니다",
    "write": "처리가 아직 끝나지 않아 보기만 할 수 있습니다",
  },
  "colorPicker": {
    "changeColor": "색상 변경: {{target}}",
  },
  "folder": {
    "newFolder": "새 폴더",
    "newFolderNamed": "{{name}} 새 폴더",
    "createChild": "하위 폴더 만들기",
    "rename": "이름 변경",
    "duplicate": "복제",
    "duplicating": "복사 중…",
    "move": "이동",
    "moveToFolder": "폴더로 이동",
    "moveUp": "위로 이동",
    "moveDown": "아래로 이동",
    "delete": "삭제",
    "cancel": "취소",
    "root": "최상위",
    "moveTargets": "이동할 위치",
    "nameInput": "폴더 이름",
    "saveName": "이름 저장",
    "cancelName": "이름 편집 취소",
    "itemCount": "{{count}}개",
    "folderMenu": "폴더 메뉴: {{name}}",
    "itemMenu": "항목 메뉴: {{name}}",
    "lock": "잠금",
    "unlock": "잠금 해제",
    "lockedRow": "잠김: {{name}}",
    "showToggle": "폴더 표시: {{name}}",
    "sizePartial": "{{size}} 이상",
    "deleteTitle": "폴더 삭제",
    "deleteMessage": "'{{name}}' 폴더를 삭제하시겠습니까?",
    "deleteMessageWithSubfolders": "'{{name}}' 폴더와 하위 폴더를 합쳐 {{count}}개의 폴더를 삭제하시겠습니까?",
    "deleteSubMessage": "안에 있던 항목 {{count}}개는 폴더 밖으로 나오고, 데이터는 삭제되지 않습니다.",
    "deleteSubMessageWithItems": "안에 있던 항목 {{count}}개도 함께 삭제됩니다.",
    "deleteSubMessageNoItems": "폴더 안에 항목이 없어 폴더만 삭제됩니다.",
    "loadFailedNamed": "{{name}} 폴더를 불러오지 못했습니다",
    "selectedCount": "{{count}}개 선택됨",
    "selectionHint": "함께 끌어 한 폴더로 옮길 수 있습니다",
    "selectionMaxed": "한 번에 옮길 수 있는 최대 개수입니다",
    "clearSelection": "선택 해제",
    "error": {
      "forbidden": "폴더를 변경할 권한이 없습니다.",
      "notFound": "대상 폴더나 항목이 없어졌습니다. 목록을 새로 불러옵니다.",
      "failed": "폴더 작업에 실패했습니다.",
      "notSent": "폴더 작업을 보내지 못했습니다. 잠시 후 다시 시도해 주세요.",
      "uploadNotPlaced": "업로드한 파일을 폴더에 넣지 못해 최상위에 두었습니다.",
      "moveTooMany": "한 번에 {{max}}개까지 옮길 수 있습니다. 체크를 줄인 뒤 다시 끌어 주세요."
    }
  },
  "projects": {
    "projectInfo": "프로젝트 정보",
    "application": "어플리케이션",
    "projectList": "프로젝트 리스트",
    "checkingApplication": "2D(이미지) & 3D(모델) 기반 점검",
    "portinfraApplication": "항만 인프라 안전점검",
    "slopeAppication": "비탈면 유지관리",
    "constructingApplication": "항만 시설물 안전점검",
    "cadastralApplication": "용지도 관리(Beta)",
    "managingDroneImages": "드론 이미지",
    "droneImages": "드론 이미지 매핑",
    "summaryMapping": "이미지 매핑 요약",
    "waitingMapping": "매핑 대기",
    "managingProjectGroup": "프로젝트 그룹",
    "managingEtcData": "기타 데이터",
    "roadIssue": "도로 포장 이슈 탐지",
    "newProject": "새 프로젝트",
    "newProjectCreate": "새 프로젝트 생성",
    "droneImagesCount": "드론이미지수",
    "droneImageMapping": "이미지 매핑",
    "imageMapingProcess": "이미지 매핑 프로세스",
    "processCondition": "처리 상태",
    "orthomosaicDown": "정사영상[TIF]",
    "pointcloudDown": "3D 포인트 클라우드[LAS]",
    "meshDown": "3D 매쉬[OBJ]",
    "dsmDown": "수치표면모델[DSM-TIF]",
    "dataDown": "이미지 매핑 결과물 다운로드",
    "message": {
      "failedCreatingContent": "게시물 생성 실패",
      "deletedContent": "게시물 삭제 완료",
      "failedDeletedContent": "게시물 삭제 실패",
      "makeSureDeleteProject": "프로젝트를 삭제 하시겠습니까?",
      "makeSureDeleteTimeSeries": "정말 시계열을 삭제 하시겠습니까?",
      "warningDeleteTimeSeries": "이 작업은 되돌릴 수 없습니다. \n 시계열을 삭제하면 관련된 모든 데이터가 제거되며 이슈 및 측정 기록, 리포트 등 모든 정보가 영구적으로 삭제됩니다.",
      "processingMapping": "드론 이미지 매핑 처리가 완료되면 확인할 수 있습니다",
      "processingMappingDownload": "드론 이미지 매핑 처리가 완료되면 데이터를 다운로드 받을 수 있습니다",
      "accessDeniedAdmin": "어드민 계정은 접근할 수 없습니다",
      "makeSureModifyProject": "프로젝트를 수정 하시겠습니까?",
      "makeSureDeleteFolder": "폴더를 삭제하시겠습니까?",
      "successUpload": "업로드 완료",
      "failedUpload": "업로드 실패",
      "uploadedImage": "업로드 된 이미지",
      "refreshAfterUploaded": "업로드를 마치면 새로고침 버튼을 눌러주세요.",
      "imageDeleteCompleted": "이미지 삭제가 완료되었습니다.",
      "imageUpload10": "이미지가 10장 이상 업로드되어야 합니다.",
      "notSelectedImage": "이미지를 선택 해주세요.",
      "deleteCompleted": "삭제에 성공했습니다.",
      "failedDeleting": "삭제에 실패했습니다.",
      "typeProjectName": "프로젝트명을 입력해주세요.",
      "deleteTimeSeries": "시계열 삭제",
      "ifYouWantToDeleteTimeSeries": "위 시계열의 삭제를 원한다면",
      "addTimeSeries": "시계열 추가",
      "duplicateTimeSeries": "같은 날짜의 시계열이 존재합니다.",
      "failedCreating": "생성 실패",
      "successCreating": "생성 완료"
    }
  },
  "auth": {
    "message": {
      "loginFailed": "로그인 실패",
      "confirmFailed": "인증 실패",
      "resendingConfirmationCode": "인증 코드를 재발송 했습니다.",
      "confirmationCodeResendingFail": "재전송 실패",
      "fillEmail": "기존에 가입하신 이메일을 입력해주세요.",
      "sendCodeNumber": "인증번호를 보내드립니다.",
      "sentCodeNumber": "인증번호가 발송되었습니다.",
      "sendCodeNumberFailed": "인증번호 전송 실패",
      "changePassWordFailed": "비밀번호 변경 실패",
      "notMatchCode": "인증번호는 6자리 숫자입니다."
    }
  },
  "inspection2d": {
    "projectInfo": "프로젝트 정보",
    "projectModify": "프로젝트 정보 수정",
    "layerInfo": "레이어",
    "issueInfo": "이슈/측정",
    "managingBim": "3D 관리",
    "report": "리포트",
    "mainLayer": "주 레이어",
    "issueType": "이슈 툴",
    "issueName": "이슈 이름",
    "createIssue": "이슈 생성",
    "typeByXY": "X-Y 좌표",
    "typeByLatLng": "경위도 좌표",
    "issueList": "이슈 사항",
    "issueDegree": "이슈 정도",
    "msg": {
      "nonNegativeNumber": "높이값은 양수여야 합니다.",
      "tooSmallArea": "체적 정보를 구하기 위한 너비가 너무 좁습니다.",
      "notAnyMatchIssue": "일치하는 이슈가 없습니다.",
      "makeIssue": "이슈를 등록해주세요.",
      "annotaionFixSuccess": "이슈 수정 완료",
      "nonAnnotation": "선택된 어노테이션이 없거나 통신 오류",
      "projectLoading": "프로젝트 불러오는 중...",
      "notMyProject": "소유하지 않은 프로젝트입니다.",
      "layerLoading": "레이어 정보 불러오는 중...",
      "creationAnnotation": "어노테이션 생성 완료",
      "failedCreationAnnotation": "어노테이션 생성 실패",
      "loadingFilterInfo": "필터링 정보 불러오는 중...",
      "successDeleting": "삭제에 성공했습니다.",
      "failedDeleting": "삭제가 실패했습니다.",
      "loadingLongitudianlInfo": "단면 정보를 불러오는 중...",
      "outOfRangeMessage": "대상지역을 벗어났습니다.",
      "loadingIssuelInfo": "이슈 정보를 불러오는 중...",
      "errorLoadLongitudinalInfo": "단면 정보를 불러오지 못했습니다.",
      "loadingPage": "페이지 불러오는 중...",
      "loadingData": "데이터 불러오는 중...",
      "loadingAnnotation": "어노테이션 불러오는 중...",
      "checkPositionByClickingMap": "지도를 클릭하여 좌표를 확인하세요.",
      "loadingMeasurementInfo": "측정 정보를 불러오는 중...",
      "noMeasure": "측정 정보가 없습니다.",
      "noLength": "높이 정보가 없습니다.",
      "noDSM": "DSM 정보가 없습니다.",
      "noLayer": "레이어가 없습니다.",
      "pleaseSelectACrossSection": "단면 선택",
      "noCrossSection": "대상 지역을 벗어났습니다.",
      "validateStepDigit": "정수 2자리, 소수점 이하 1자리 이내로 입력해주세요.",
      "validateStepLength": "각 선분의 길이보다 간격을 작게 입력해주세요.",
      "longitudinalIntervalError": "점 간격을 정수 2자리, 소수점 이하 1자리 이내, 1m 이상 입력해주세요.",
      "longitudinalWidthError": "좌, 우 폭이 점 간격보다 커야 합니다.",
      "startOverEnd": "시작일이 종료일보다 이후입니다.",
      "endBeforeStart": "종료일이 시작일보다 이전입니다.",
      "createdOverStart": "시작일이 프로젝트 생성일보다 이전입니다.",
      "loading3DTiles": "메쉬 모델 데이터 불러오는 중...",
      "loading3DTilesError": "메쉬 모델 로드에 실패했습니다."
    }
  },
  "inspection3d": {
    "layers": "레이어",
    "model": "모델",
    "issue": "이슈",
    "measure": "측정",
    "profile": "3D 단면 프로파일",
    "distance": "거리",
    "lowQuality": "저해상도",
    "highQuality": "고해상도",
    "opacity": "투명도",
    "msg": {
      "underMaintenance": "기능 점검중",
      "loading3DModel": "3D 모델 생성중",
      "modelServerError": "3D 모델 서버 오류.",
      "modelError": "3D 모델 생성 실패.",
      "syncLayer": "레이어 정보 동기화중",
      "syncLayerError": "레이어 정보 동기화 실패",
      "noModel": "구축된 모델이 없습니다.",
      "noIssues": "이슈 없음",
      "syncIssues": "이슈 동기화중",
      "issueLoadError": "이슈 로드 실패",
      "issueCreationSuccess": "이슈 생성 성공",
      "issueCreationError": "이슈 생성 실패",
      "issueSaveSuccess": "이슈 저장 완료",
      "issueSaveError": "이슈 저장 실패",
      "issueDeleteSuccess": "이슈 삭제 완료",
      "issueDeleteError": "이슈 삭제 실패",
      "issueAreaError": "이슈 생성은 모델 영역에서 가능합니다.",
      "profileAreaError": "단면도 생성은 모델 영역에서 가능합니다.",
      "imageAreaError": "이미지 확인은 모델 영역에서 가능합니다.",
      "measurementAreaError": "측정은 모델 영역에서 가능합니다.",
      "twoPointCountError": "두 개 이상의 점을 생성하세요.",
      "threePointCountError": "세 개 이상의 점을 생성하세요.",
      "rightClickHint": "우클릭 시 취소",
      "doubleClickConfirm": "더블클릭으로 확정",
      "profileSectionSummary": "구간 {{count}}개 · 총 길이 {{length}} m",
      "leftClickRemove": "좌클릭 시 삭제",
      "clickToLoadImage": "클릭으로 근처 이미지 확인",
      "profileCoordinateLoading": "좌표 계산중",
      "measurementRightClick": "우클릭 시 종료",
      "getNearbyImages": "클릭으로 주변 이미지를 불러옵니다.",
      "switchingTimeSeries": "시계열 전환 중...",
      "loadingModelList": "모델 목록 확인 중...",
      "loadingModelInfo": "3D 모델 정보 내려받는 중...",
      "loadingModelTiles": "3D 모델 그리는 중...",
      "meshLoadFailed": "{{name}} 모델을 불러오지 못했습니다",
      "meshLoadStalled": "일부 데이터를 불러오지 못했습니다",
      "meshLoadStalledNamed": "{{names}} 데이터를 불러오지 못했습니다",
      "meshLoadAllFailed": "3D 모델을 불러오지 못했습니다",
      "retry": "다시 시도",
      "loadingBim": "BIM 불러오는 중...",
      "loadingPointCloud": "포인트 클라우드 불러오는 중...",
      "loadingGisLayers": "GIS 레이어 불러오는 중...",
      "loadingLinearLayers": "선형 레이어 불러오는 중...",
      "stageBim": "BIM",
      "stagePointCloud": "포인트 클라우드",
      "stageGis": "GIS 레이어",
      "stageLinear": "선형 레이어",
      "stageLoadFailed": "{{name}} 로드에 실패해 건너뜁니다",
      "stageLoadStalled": "{{name}} 로드가 지연되어 건너뜁니다",
      "layerLoadFailed": "{{name}} 레이어를 불러오지 못했습니다"
    },
    "measureAxis": {
      "axisSolid": "입체",
      "axisPlane": "평면",
      "axisHeight": "높이",
      "axisHorizontal": "수평",
      "axisSolidArea": "입체 면적",
      "axisPlaneArea": "평면 면적"
    },
    "tooltip": {
      "showHide": "표시/숨김",
      "flyToLayer": "모델로 이동",
      "flyToMesh": "모델로 이동",
      "adjustOpacity": "투명도 조절",
      "help": {
        "showHide": "레이어 표시/숨김",
        "flyToLayer": "모델로 이동",
        "adjustOpacity": "투명도 조절"
      }
    }
  },
  "mapTool": {
    "guide": {
      "button": {
        "click": "클릭",
        "doubleClick": "더블클릭",
        "rightClick": "우클릭",
        "release": "놓기",
        "drag": "끌기",
        "clickPlus": "클릭(＋)",
        "rightClickPoint": "우클릭(점)"
      },
      "action": {
        "createPoint": "점 생성",
        "finish": "완료",
        "cancel": "취소",
        "undo": "되돌리기",
        "removeMeasurement": "측정 삭제",
        "nearbyImage": "근처 이미지 확인",
        "placeEquipment": "배치",
        "movePoint": "점 옮기기",
        "removePoint": "점 지우기",
        "appendPoint": "끝에 점 추가"
      },
      "precisePending": "정밀 생성중…"
    }
  },
  "graph": {
    "checkCrossSection": "횡단면 확인",
    "checkLongitudeSection": "종단면 확인",
    "openSectionGraph": "단면 그래프 열기: {{target}}",
    "height": "고도",
    "distance": "거리",
    "line": "선형",
    "alignment": "선형",
    "lineLayerNotFound": "선택한 레이어의 선형 데이터를 찾을 수 없습니다. 관리자에게 문의해주세요.",
    "layerToggleFailed": "레이어 변경에 실패했습니다",
    "layerColorChangeFailed": "레이어 색상 변경에 실패했습니다",
    "stratum": "지층",
    "designHeight": "계획고",
    "check": "확인",
    "longitudeSection": "종단면",
    "specificSection": "특정",
    "crossSection": "횡단면",
    "crossSectionList": "횡단면 리스트",
    "perpendicularInterval": "횡단 간격",
    "pointInterval": "점 간격",
    "pointSetting": "지점 설정",
    "detailSetting": "세밀화 설정",
    "startPoint": "시작점",
    "endPoint": "끝점",
    "section": "구간",
    "sectionStartPoint": "시점",
    "sectionEndPoint": "종점",
    "original": "원본 보기",
    "detail": "세밀화 보기",
    "startPointError": "시작 측점은 기본 값보다 작을 수 없습니다.",
    "enterBranch": "지점을 입력해주세요.",
    "validate": {
      "dxfSaveFileDownloadError": "파일 다운로드 중 오류가 발생했습니다. 다시 시도해주세요.",
      "dxfSaveFileGenerateNotice": "파일 생성 요청되었습니다. 보통 10분 이내 완료됩니다. 잠시 후에 확인 해주세요.",
      "dxfSaveFileGenerateError": "파일 생성에 실패했습니다. 잠시 후 다시 시도해주세요.",
      "noSavedData": "저장된 데이터가 없습니다.",
      "failDeleteData": "데이터를 삭제하는데 실패했습니다. 다시 시도해주세요.",
      "savePerpendicular": "횡단면이 저장되었습니다.",
      "deletePerpendicular": "횡단면이 삭제되었습니다.",
      "existingCrossSection": "이미 저장된 횡단면이 있습니다. 삭제 후 다시 시도해주세요.",
      "longitudinalPointIntervalMinValue": "은(는) 1 이상이어야 합니다.",
      "perpendicularIntervalMinValue": "은(는) 1 이상이어야 합니다.",
      "perpendicularWidthMinValue": "은(는) 1 이상이어야 합니다.",
      "duplicatePointError": "동일한 지점이 있습니다. 중복된 지점을 확인해주세요.",
      "endPointInfo": "종점을 입력하지 않거나 종점이 선형 길이보다 길다면 전체 단면을 볼 수 있습니다.",
      "lngStartPoint": "종단면의 시작측점은 TEXT 파일에만 반영됩니다.",
      "startStepError": "시점은 기본 값보다 작을 수 없습니다.",
      "endStepError": "종점은 시점보다 작을 수 없습니다.",
      "sameStepError": "시점과 종점은 같을 수 없습니다.",
      "performanceWarning": "컴퓨터 성능에 따라 브라우저가 멈출 수 있습니다. 멈춘 경우 새로고침 후 점간격을 늘리거나 구간을 줄여 사용해 주세요.",
      "maxStratumFilesSelected": "파일은 최대 세 개까지만 선택할 수 있습니다.",
      "maxStep": "간격은 100 이하이어야 합니다.",
      "increment": "간격은 5의 배수이어야 합니다.",
      "equal": "점 간격은 횡단 간격보다 같거나 작아야 합니다.",
      "setPoint": "시작점과 끝점을 설정해주세요",
      "pointAdditionError": "추가 지점은 시작측점보다 작을 수 없습니다.",
      "pointAdded": "특정 횡단면이 추가되었습니다.",
      "pointAdditionFailed": "특정 횡단면 추가에 실패했습니다. 잠시후 다시 시도해주세요.",
      "pointAdditionTargetFailed": "이미 해당 거리에 횡단면이 있습니다. 입력한 거리를 확인해주세요.",
      "distanceExceedsSegmentLength": "입력한 거리가 선분의 길이를 초과했습니다.",
      "crossSectionDeletionFailed": "횡단면 삭제에 실패했습니다. 잠시후 다시 시도해주세요."
    }
  },
  "myPage": {
    "accountInfo": "계정 정보",
    "quit": "회원탈퇴",
    "quitAgreement": "회원 탈퇴 약관",
    "quitAggrementDescription": {
      "first": "이용자의 개인정보는 원칙적으로 개인정보 수집 및 이용목적이 달성되면 지체없이 파기 합니다. 다만, 다른 법령에 의해 보관해야 하는 정보는 법령이 정한 기간 동안 별도 분리 보관 후 파기합니다.",
      "second": "   가. 파기절차 및 기한 수집·이용목적이 달성된 개인정보는 지체없이 파기되며, 관련 법령에 따라 보관되어야 할 경우 별도의 DB 에 옮겨져 내부 규정 및 관련 법령을 준수하여(개인정보 보유 및 이용기간) 일정기간동안 안전하게 보관된 후 지체없이 파기됩니다. 이때, DB 로 옮겨진 개인정보는 법률에 의한 경우를 제외하고 다른 목적으로 이용하지 않습니다.",
      "third": " 나. 파기방법 전자적 파일 형태의 정보는 복구 및 재생할 수 없는 기술적 방법을 사용하여 완전하게 삭제합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.",
      "fourth": "안내 사항을 모두 확인하였으며, 이에 동의합니다."
    },
    "msg": {
      "atLeastOneSpecialCharacter": "비밀번호는 최소한 한개 이상의 특수문자를 포함해야 합니다.",
      "atLeastOneDigit": "비밀번호는 최소한 한개 이상의 숫자를 포함해야 합니다.",
      "passwordLength": "비밀번호는 8글자 이상이어야 합니다.",
      "atLeastOneLowerCaseLetter": "비밀번호는 최소한 한개 이상의 소문자를 포함해야 합니다.",
      "passwordNeedCapital": "비밀번호는 최소한 한개 이상의 대문자를 포함해야 합니다.",
      "onlyNumber": "숫자만 입력해주세요.",
      "notEnoughLength": "올바른 길이가 아닙니다.",
      "checkVerifyingEmail": "메일로 발송된 인증번호를 입력하세요.",
      "makeSureQuiteQuestion": "회원 탈퇴 하시겠습니까?",
      "makeSureQuitDoubleCheck": {
        "ko": "회원 탈퇴를 원하신다면, '계정 삭제' 를 입력해 주세요.",
        "en": "If you wish to withdraw your membership, please enter &quot;Account Deletion",
        "checkWord": "계정 삭제"
      },
      "checkDuplicatedEmail": "이메일 중복을 확인해주세요.",
      "idAllowEngNumber": "올바른 이메일 형식을 입력하세요.",
      "emailAlreadyExists": "이미 존재하는 아이디입니다.",
      "newtworkError": "네트워크 오류로 현재 중복 확인이 불가합니다.",
      "usableEmail": "사용 가능한 이메일입니다.",
      "notMatchPassword": "비밀번호가 일치하지 않습니다.",
      "failedModifiedUser": "회원정보 수정에 실패했습니다.",
      "warningTypicalform": "형식으로 입력해주세요",
      "warningQuitDescription": "탈퇴 안내를 확인하고 동의해 주세요.",
      "joinCompleted": "회원가입이 완료되었습니다.",
      "accountDeleted": "계정이 삭제되었습니다."
    }
  },
  "userManagement": {
    "manageProjectPermission": "프로젝트 권한 관리",
    "addUser": "사용자 추가",
    "delete": "삭제",
    "joinStatus": "가입 상태",
    "joined": "가입",
    "unjoined": "미가입",
    "msg": {
      "userAdding": "변경사항 반영 중입니다.",
      "userAdded": "사용자가 추가되었습니다.",
      "userDeleted": "사용자가 삭제되었습니다.",
      "userEdited": "사용자 권한이 수정되었습니다.",
      "confirmUserDelete": "사용자를 프로젝트에서 삭제하시겠습니까?",
      "errorUserEdit": "네트워크 오류로 현재 수정이 불가합니다.",
      "errorUserDelete": "네트워크 오류로 현재 삭제가 불가합니다.",
      "projectFirst": "프로젝트를 먼저 생성해주세요.",
      "projectsListing": "프로젝트 리스트 불러오는 중."
    }
  },
  "header": {
    "service": "서비스",
    "platform": "플랫폼",
    "survey": "드론 측량 / 공간데이터 가공",
    "plan": "이용플랜",
    "contact": "1:1 문의",
    "manual": "메뉴얼",
    "project": "프로젝트",
    "myPage": "마이페이지",
    "auth": {
      "login": "로그인",
      "logging": "로그인 중...",
      "logout": "로그아웃",
      "join": "회원가입",
      "sendingcode": "인증 번호 전송중...",
      "changepw": "비밀번호 변경",
      "changingpw": "비밀번호 변경중...",
      "verifyemail": "이메일 인증하기"
    }
  },
  "sideNav": {
    "error": {
      "nonProject": "프로젝트 하나를 선택해 주세요."
    }
  },
  "constants": {
    "text": "텍스트",
    "polygon": "다각형",
    "rectangle": "사각형",
    "marker": "마커",
    "severity": "심각도",
    "importance": "중요도",
    "urgenty": "긴급도",
    "imageupload": "이미지 업로드",
    "checkall": "전체 선택",
    "distance": "거리(m)",
    "height": "고도(m)",
    "pointBim": "포인트 빔",
    "image": "이미지",
    "optimizedImage": "(최적화/원시)",
    "video": "비디오",
    "document": "문서",
    "layer": "레이어",
    "noLayer": "선택 가능한 레이어가 없습니다.",
    "layerSelect": "레이어를 선택 해주세요.",
    "projectName": "프로젝트명",
    "project": "프로젝트",
    "address": "주소",
    "position": "좌표(위경도)",
    "infraType": "인프라 타입",
    "goBack": "뒤로가기",
    "opacity": "투명도",
    "loadingCalInfo": "측정 정보 불러오는 중...",
    "searchAddress": "주소 검색",
    "requiredValue": "필수 값입니다.",
    "handsOnWriting": "직접 입력",
    "updatedDate": "수정날짜",
    "completedDate": "완료일",
    "completed": "완료",
    "objectType": "객체 타입",
    "memo": "메모",
    "tag": "태그",
    "keyword": "키워드",
    "cancel": "취소",
    "save": "저장",
    "makeIssueTitle": "이슈 제목을 입력하세요.",
    "modify": "수정",
    "other": "기타",
    "deleting": "삭제",
    "delete": "삭제하기",
    "search": "검색",
    "add": "추가",
    "remove": "제거",
    "issueList": "이슈 사항 목록",
    "type": "타입",
    "beforeProcess": "처리 전",
    "processing": "처리 중",
    "processCompleted": "처리 완료",
    "processFailed": "처리 실패",
    "twoDimensionImage": "2D 이미지",
    "threeDimensionImage": "3D 이미지",
    "requestedProcess": "처리 요청",
    "checkingRequest": "검수 중",
    "coordinateSystem": "출력 좌표계",
    "resolution": "해상도(GSD)",
    "download": "다운로드",
    "update": "업데이트",
    "downing": "다운 중",
    "checking": "확인 중",
    "createFile": "파일 생성",
    "creating": "생성 중",
    "group": "그룹",
    "preview": "미리보기",
    "none": "없음",
    "edit": "편집",
    "editModeMeasureNotice": "편집 모드 종료 시 계산값이 업데이트됩니다",
    "volumeCalculationFailed": "체적 계산에 실패했습니다. 다시 시도해 주세요.",
    "orthomosaicImage": "정사영상",
    "gisLayer": "GIS 레이어",
    "subLayer": "보조 레이어",
    "annotation": "어노테이션",
    "latitude": "위도",
    "latitudeShorten": "위도",
    "longitude": "경도",
    "longitudeShorten": "경도",
    "location": "위치",
    "create": "생성",
    "annotationType": "어노테이션 타입",
    "issueDescription": "이슈 사항",
    "issueDegree": "이슈 정도",
    "issueGrade": "이슈 단계",
    "createIssue": "이슈 생성",
    "date": "날짜",
    "createdDate": "생성 날짜",
    "reset": "초기화",
    "check": "확인",
    "filtering": "필터링",
    "totalIssue": "총이슈",
    "cases": " 건",
    "measurement": "측정",
    "information": " 정보",
    "coordinates": "좌표",
    "area": "면적",
    "surfaceArea": "표면적",
    "line": "선분",
    "length": " 길이",
    "elevationDifference": "고도 차",
    "slope": "경사",
    "volume": "체적",
    "setFloorHeight": "바닥면 높이(m)",
    "volumeCalculate": "체적 계산",
    "volumeBaseMode": "바닥면",
    "baseModeCustom": "기준고 직접 입력",
    "baseModeTriangulated": "경계점 삼각망",
    "baseModeMean": "경계점 평균고",
    "volumeGuideTitle": "체적 계산 가이드",
    "volumeGuideOpen": "체적 계산 가이드 열기",
    "close": "닫기",
    "baseModeCustomDesc": "직접 입력한 고도로 생성한 수평면을 기준 바닥면으로 체적을 계산합니다. 수평면 위는 절토량, 아래는 성토량입니다.",
    "baseModeTriangulatedDesc": "폴리곤 경계에 찍은 꼭짓점들을 이어 삼각망을 형성하고, 지형 경사를 따르는 바닥면을 기준으로 체적을 계산합니다.",
    "baseModeMeanDesc": "폴리곤 경계에 찍은 꼭짓점들의 지형 고도를 평균한 수평면을 기준으로 체적을 계산합니다.",
    "volumeOutOfRasterBounds": "측정 영역이 지형 고도 데이터 범위를 벗어나 체적을 계산할 수 없습니다.",
    "crossSection": "단면",
    "sectionAndCrossSection": "단면 · 횡단면",
    "startingSidePoint": "시작 측점",
    "setSpacing": "간격 설정",
    "checkTheCrossSection": "단면 확인",
    "cutVolume": "CUT(절토량)",
    "fillVolume": "FILL(성토량)",
    "netVolume": "순체적",
    "settingInterval": "단면 간격(m)",
    "startingSurveyPoint": "시작 측점(m)",
    "checkCrossSection": "단면 확인",
    "longitudeGraph": "고도 프로파일",
    "longitudeSliderNotice": "오른쪽 슬라이더를 사용해 고도 프로파일의 급격한 변화 지점을 중심으로 데이터량을 조절할 수 있습니다.",
    "longitudeDetailNotice": "그래프에서 자세하게 보고 싶은 부분의 점 간격을 입력하고 시작점과 끝점을 선택해주세요.",
    "perpendicular": "종횡단면",
    "perpendicularGraph": "횡단면 고도 프로파일",
    "perpendicularWidth": "폭 설정",
    "left": "좌",
    "right": "우",
    "perpendicularInterval": "횡단 간격",
    "longitudeGraphPart": "부분 보기",
    "longitudeGraphTotal": "전체 보기",
    "total2DLength": "총 2D 길이",
    "total3DLength": "총 3D 길이",
    "planeDistance": "평면(2D) 거리",
    "solidDistance": "입체(3D) 거리",
    "surfaceDistance": "표면 거리",
    "planeArea": "평면(2D) 면적",
    "solidArea": "입체(3D) 면적",
    "planeDistanceTooltip": "높이를 무시하고 수평으로 투영한 직선 거리입니다.",
    "solidDistanceTooltip": "두 점의 높이차까지 반영한 3D 직선 거리입니다.",
    "surfaceDistanceTooltip": "지형(메쉬) 표면의 굴곡을 따라간 실제 거리입니다.",
    "planeAreaTooltip": "높이를 무시하고 수평으로 투영한 면적입니다.",
    "solidAreaTooltip": "꼭짓점의 높이차를 반영해 평면으로 이은 면적입니다.",
    "surfaceAreaTooltip": "지형(메쉬) 표면의 굴곡까지 반영한 실제 면적입니다.",
    "upload": "업로드",
    "totalAmount": "총 용량",
    "writer": "작성자",
    "organization": "소속",
    "title": "제목",
    "rank": "직급",
    "email": "이메일",
    "permission": "권한",
    "createReport": "리포트 작성",
    "id": "아이디",
    "username": "이름",
    "no": "번호",
    "phone": "휴대폰 번호",
    "major": "분야",
    "job": "직무",
    "mypage": "마이페이지",
    "heightProfile": "고도 프로파일",
    "imageList": "이미지 리스트",
    "total": "총",
    "imagesCounting": "개",
    "all": "전체",
    "near": "근처",
    "noneImages": "이미지가 없습니다.",
    "loadingImages": "이미지 로딩중",
    "requestMapping": "요청하기",
    "requestCompleted": "요청완료",
    "password": "비밀번호",
    "doubleCheck": "비밀번호 확인",
    "linkPositions": "위치 연계",
    "idDoubleCheck": "중복확인",
    "user": "사용자",
    "submit": "확인",
    "resend": "재전송",
    "next": "다음",
    "code": "인증번호",
    "filter": "필터",
    "apply": "적용",
    "acquired": "촬영일"
  },
  "pdf": {
    "author": "작 성 자",
    "organization": "소 속",
    "rank": "직 무",
    "email": "이 메 일",
    "report": " 리포트",
    "groupAssociations": "그룹 연계",
    "issue": "이슈",
    "issueName": "이슈명",
    "count": "개",
    "layout": "배치도",
    "summary": "요약",
    "issueLevel": "이슈정도",
    "issueType": "이슈타입",
    "issuePriority": "우선순위",
    "comment": "의견",
    "acquired": "데이터 취득날짜",
    "msg": {
      "loadingPdf": "pdf를 불러오는 중..."
    }
  },
  "pricing": {
    "standard1": "월 구독 방식",
    "standard1_2": "(이미지 중복도 80% 이상 유지)",
    "standard2": "드론 이미지 3000장 / 드론프로젝트 구축",
    "standard3": "월 2회 데이터 처리",
    "standard4": "이미지 매핑 결과물 다운로드",
    "advanced1": "년 구독 방식으로 각종 사용 옵션을 유연하게 협의",
    "advanced1_2": "",
    "contactUs": "문의하기",
    "title": "드론스퀘어 서비스 플랜",
    "description1": "드론스퀘어가 제공하는 정확한 데이터 분석으로 현장을 모니터링하고",
    "description2": "최적의 유지보수를 실현하세요.",
    "standard_subtitle": "소수의 대상 객체(현장)를 분석하고 관리하고자 하는 경우",
    "advanced_subtitle": "다수의 대상 객체(현장)을 분석하고 관리하고자 하는 경우"
  }
} as const;

export default common;
